import React from 'react';
import { Link } from 'react-router-dom';

const Notfound = () => {
  return (
    <div 
      className="d-flex flex-column align-items-center justify-content-center min-vh-100 text-center px-3"
      style={{
        backgroundColor: '#fbfbfe',
        backgroundImage: 'radial-gradient(circle at center, rgba(124, 58, 237, 0.08) 0%, transparent 70%)',
        paddingTop: '80px'
      }}
    >
      <div className="cb-badge mb-3">
        <span className="cb-badge-dot"></span>
        <span>{"Error 404 // Lost in Latent Space"}</span>
      </div>
      <h1 
        className="cb-gradient-text fw-bold mb-3"
        style={{ fontSize: 'clamp(4rem, 12vw, 8rem)', letterSpacing: '-0.04em', lineHeight: 1 }}
      >
        404
      </h1>
      <h2 className="mb-3" style={{ fontSize: '1.8rem', color: '#0f172a', fontWeight: 800 }}>
        Trajectory Not Found
      </h2>
      <p className="mb-4" style={{ maxWidth: '480px', fontSize: '1.05rem', lineHeight: 1.6, color: '#475569' }}>
        The molecular sequence or research page you requested could not be resolved by our community.
      </p>
      <Link to="/" className="cb-btn-primary">
        <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="me-2">
          <path d="m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
          <polyline points="9 22 9 12 15 12 15 22"></polyline>
        </svg>
        <span>Return to ChemBioAI Home</span>
      </Link>
    </div>
  );
};

export default Notfound;